import axios from "axios";
import insurable from "../../models/common/insurable";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }
  getInsurable() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/asegurables/${operid}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return insurable.fromJson(item);
        });
      });
  }
}
export default service;
